import React, { ComponentType } from 'react';
import Image from 'next/image';
import { Typography, Box } from '@mui/material';

const GettyImages: ComponentType<any> = ({ area, block, frequency }) => {
  const { images } = block.attributes;

  return (
    <Box
      data-og-block-area={area}
      data-og-block-nth={frequency}
      sx={{ width: '100%' }}
    >
      {images &&
        images.map(
          (
            image: { uri: string; caption: string; credit: string },
            index: number
          ) => (
            <Box
              key={index}
              sx={{
                position: 'relative',
                display: 'block',
                margin: '5px auto', // Centers the images
                borderRadius: '8px',
                overflow: 'hidden',
                width: '100%', // Full width
                paddingBottom: '20px',
              }}
            >
              {/* Image wrapper with relative positioning */}
              <Box sx={{ position: 'relative' }}>
                <Image
                  src={image.uri}
                  alt={`Getty Image ${index + 1}`}
                  layout="responsive"
                  width={1000}
                  height={1000}
                  style={{ borderRadius: '8px' }}
                />

                {/* Overlay Credit */}
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: '6px',
                    left: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    color: '#fff',
                    padding: '4px 8px',
                    fontSize: '12px',
                    borderTopRightRadius: '6px',
                    borderBottomLeftRadius: '6px',
                  }}
                >
                  {image.credit}
                </Box>
              </Box>
              {/* <p>{image.credit}</p> */}
              <Typography variant="body2" sx={{ marginTop: '5px' }}>
                {image.caption}
              </Typography>
            </Box>
          )
        )}
    </Box>
  );
};

export default GettyImages;
